import { Presentation } from "../lib/types";

const pinkBg = require("./img/pinky.png");
const mintBg = require("./img/minty.png");
const logo = require("./img/logo.png");
const reactLogo = require("./img/react-logo.svg");
const expensiveImg1 = require("./img/expensive.png");

const presentation: Presentation = {
	title: "readme",
	style: {
		backgroundImage: `url(${pinkBg})`,
	},
	theme: {
		primaryColor: "rgb(100, 90, 180)",
		secondaryColor: "rgb(218, 197, 173)",

		transition: "swipeDown",
	},
	slides: [
		{
			content: `

<div>

# Box of Slides
## An easy to use presentation framework

</div>

<img src="${reactLogo}" alt="react logo" class="rotate--9" width="400"/>
`,
			justify: "-",
			notes: `
You can add speaker notes to read while giving your presentation!
Features:
  1. Notes with whitespace support
  2. Slide navigation
    -  (With mouse or keyboard!)
  3. Time your presentation
  4. Controls panel can be detached from your presentaton
  5. Dark theme!
            `,
		},
		{
			content: `
# Why make my own framework?
`,
		},
		{
			content: `
## Things cost money

<img src="${expensiveImg1}" alt="expensive cost of current solutions" style="max-height: 80%"/>
`,
			justify: "-",
		},
		{
			content: `

<div>

### What does a slide look like?

Slides are rendered using [markdown-it](https://github.com/markdown-it/markdown-it)
so all of the content is just markdown

</div>

~~~
content: \`
 # Questions
 1. Why did I make this framework?
 2. What can this framework do?
 3. What does writing a presentation look like?
\`
~~~
                `,
			justify: "|",
		},
		{
			content: `


<div>

#### Presentations can be themed to suit your mood
~~~
{
 content: '',
 theme: {
  primaryColor: "rgb(100, 90, 180)",
  secondaryColor: "rgb(218, 197, 173)",
  rootFontSize: 22pt
 }
}
~~~

</div>

<div>

#### You can also add any custom CSS to your presentation or individual slides

~~~
{
 style: {
  backgroundImage: 'url(/green_bg.png)'
 },
 slides: [
  {
   content: '',
   style: {
    backgroundImage: 'url(/pink_bg.png)'
   }
  }
 ]
}
~~~


</div>
`,
			justify: "|",
		},
		{
			content: `
## Here is a code example

Code is rendered using **Fira code** so we get font ligatures

~~~js
const HelloWorld = (props) => {
 return <h3>Hello {props.name}</h3>
}

ReactDOM.render(<HelloWorld name="Jake" />, document.getElementById("app"))
~~~
`,
		},

		{
			content: `
## Thanks for listening 🎉

<img src="${logo}" />

#### [tweet @box_of_hats](https://twitter.com/box_of_hats) [github @box-of-hats](https://github.com/Box-Of-Hats)
`,
			justify: "-",
		},
	],
};

export default presentation;
